<template>
  <MenuRef :iShow="showColor" :openKeys="SubMenu">
    <div class="sum">
      <div class="search-cond">
        <div class="search-input">
          <div class="search-item">
            <div class="tol-title">电销人员:</div>
            <a-input
              style="width: 434px; height: 40px; flex: 1 1 0%"
              v-model="form.salesman"
            />
          </div>
          <div class="search-item">
            <div class="tol-title">选择日期:</div>
            <a-config-provider :locale="locale">
              <a-month-picker
                v-model="form.dataTime"
                style="width: 434px; height: 40px; flex: 1 1 0%"
              />
            </a-config-provider>
          </div>
          <div class="search-item" style="justify-content: flex-end">
            <div class="btn-cond">
              <div>
                <a-button @click="reset" class="search-normal"> 重置 </a-button>
                <a-button
                  class="search-btn"
                  :style="{ marginLeft: '24px' }"
                  @click="searchData"
                >
                  查询
                </a-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sum-box">
        <div class="sum-view">
          <div class="tol-item">
            <div>
              <a-button class="search-normal" @click="exportData">
                导出
              </a-button>
            </div>
          </div>
        </div>
        <div class="sum-table" ref="tableContainer">
          <a-config-provider :locale="locale">
            <div>
              <a-table
                class="sum-table"
                ref="table"
                size="small"
                :columns="columns"
                :data-source="tolInformation"
                :rowKey="(record, index) => index"
                :pagination="pagination"
              ></a-table>
            </div>
          </a-config-provider>
        </div>
      </div>
    </div>
  </MenuRef>
</template>

<script>
import moment from "moment";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { getCRMData, exportCRMSumList } from "@/api";
import MenuRef from "./common/MenuRef";
import Cookies from "js-cookie";
import rolePermissions from "./rolePermissions.js";

export default {
  components: {
    MenuRef,
  },
  data() {
    return {
      permissions: {},
      SubMenu: ["sub-crm"],
      showColor: ["9"],
      form: {
        dataTime: moment().startOf("M"),
        salesman: "",
      },
      locale: zhCN,
      dateFormat: "YYYY-MM-DD HH:mm:ss",
      indexNum: 1,
      tolInformation: [],
      columns: [
        {
          title: "序号",
          key: "index",
          align: "center",
          customRender: (text, record, index) =>
            `${(this.indexNum - 1) * this.indexNum + index + 1}`,
        },
        {
          title: "月份",
          dataIndex: "month",
          align: "center",
          customRender: (text, record, index) => {
            return record.month || "/";
          },
        },
        {
          title: "电销",
          dataIndex: "salesman",
          align: "center",
          customRender: (text, record, index) => {
            return record.salesman || "/";
          },
        },
        {
          title: "电销总数",
          dataIndex: "telemarketingNumber",
          align: "center",
          customRender: (text, record, index) => {
            return record.telemarketingNumber || "/";
          },
        },
        {
          title: "邀约总数",
          dataIndex: "inviteNumber",
          align: "center",
          customRender: (text, record, index) => {
            return record.inviteNumber || "/";
          },
        },
        {
          title: "微信总数",
          dataIndex: "wechatNumber",
          align: "center",
          customRender: (text, record, index) => {
            return record.wechatNumber || "/";
          },
        },
      ],
      tableHeight: 259, 
      pageSize: 15,
      pagination: {
        pageNo: 1,
        pageSize: 15, // 默认每页显示数量
        showSizeChanger: false, // 显示可改变每页数量
        showQuickJumper: true,
        pageSizeOptions: ["15", "20", "30", "50"], // 每页数量选项
        showTotal: (total) => `共${total}条`, // 显示总数
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.onPageChange.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        buildOptionText: (pageSizeOptions) => `${pageSizeOptions.value}条/页`,
        size: "middle",
      },
    };
  },
  methods: {
    moment,
    reset() {
      this.form = {
        dataTime: moment().startOf("M"),
        salesman: "",
      };
      this.basicsData();
    },
    basicsData() {
      let params = {
        page: this.pagination.pageNo,
        size: this.pagination.pageSize,
        dataTime: moment(this.form.dataTime).format("YYYY-MM"),
        salesman: this.form.salesman,
      };
      getCRMData(params).then((res) => {
        if (res.data.list.length > 0) {
          this.tolInformation = res.data.list;
          this.pagination.total = res.data.total;
        } else {
          this.tolInformation = [];
          this.pagination.total = 0;
        }
      });
    },
    async onPageChange(page) {
      this.pagination.pageNo = page;
      this.pagination.current = page;
      await this.basicsData();
    },
    searchData() {
      this.basicsData();
    },
    exportData() {
      let params = {};

      params = {
        header: ["月份", "电销", "电销总数", "邀约总数", "微信总数"],
        headervalues: [
          "month",
          "salesman",
          "telemarketingNumber",
          "inviteNumber",
          "wechatNumber",
        ],
        dataTime: moment(this.form.dataTime).format("YYYY-MM"),
        salesman: this.form.salesman,
      };

      exportCRMSumList({ ...params }).then((data) => {
        if (!data || data.size <= 0) {
          this.$Message.error("没有数据导出失败");
          return;
        }

        let url = window.URL.createObjectURL(new Blob([data]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute(
          "download",
          `${moment().format("YYYY-MM-DD")}-CRM统计数据.xlsx`
        );

        document.body.appendChild(link);
        link.click();
      });
    },
  },
  mounted() {
    let roleId = Cookies.get("roleId");
    this.permissions = rolePermissions[roleId];
    this.basicsData();
  },
  watch: {
    // 表格高度自适应
    tolInformation: function (newVal, oldVal) {
      if (newVal.length == 0) {
        document.getElementsByClassName(
          "ant-spin-nested-loading"
        )[0].style.height = 40 + "px";
      } else {
        if (newVal.length != this.pageSize) {
          document.getElementsByTagName("table")[0].style.height = 0 + "px";
        } else {
          document.getElementsByClassName(
            "ant-spin-nested-loading"
          )[0].style.height = 100 + "%";
          document.getElementsByTagName("table")[0].style.height = 100 + "%";
        }
      }
    },
  },
};
</script>

<style lang="less">
.sum {
  height: 100%;
  width: 100%;

  .search-btn {
    background: #14cc76;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    border-color: #14cc76;
    width: 80px;
    height: 40px;
  }

  .search-btn:hover,
  .search-btn:active,
  .search-btn:focus {
    background: #14cc76;
    border-radius: 4px;
    color: #ffffff;
    border-color: #14cc76;
  }

  .search-normal {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #969998;
    border-color: #e3e6e4;
    width: 80px;
    height: 40px;
  }

  .search-normal:hover,
  .search-normal:active,
  .search-normal:focus {
    background: transparent;
    border-radius: 4px;
    color: #14cc76;
    border-color: #14cc76;
  }

  .search-delete {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ff6b4d;
    border-color: #ff6b4d;
    width: 80px;
    height: 40px;
  }

  .search-delete:hover,
  .search-delete:active,
  .search-delete:focus {
    background: transparent;
    border-radius: 4px;
    color: #ff6b4d;
    border-color: #ff6b4d;
  }

  .search-page {
    background: transparent;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #14cc76;
    border-color: #14cc76;
    width: 104px !important;
    height: 40px;
  }

  .search-page:hover,
  .search-page:active,
  .search-page:focus {
    background: transparent;
    border-radius: 4px;
    color: #14cc76;
    border-color: #14cc76;
  }

  .search-cond {
    width: 100%;
    height: 100px;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    padding: 24px;

    .search-input {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .search-item {
        width: calc(100% / 3);
        display: flex;
        align-items: center;

        .tol-title {
          width: 30%;
          display: flex;
          justify-content: flex-end;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #313332;
          line-height: 22px;
          font-style: normal;
          margin-right: 10px;
        }
      }
    }

    .search-button {
      margin-top: 8px;
      width: 100%;
      display: flex;
      align-items: center;

      .btn-cond {
        width: calc(100% / 3);
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }
  .sum-box {
    width: 100%;
    background: #ffffff;
    border-radius: 8px;
    padding: 24px;
    .title {
      display: block;
      border-bottom: solid 1px #384057;
      padding-bottom: 10px;
      overflow-wrap: break-word;
      color: rgba(255, 255, 255, 1);
      font-size: 20px;
      font-family: Alibaba-PuHuiTi-M;
      line-height: 28px;
      text-align: left;
    }
    .sum-view {
      display: flex;
      margin-bottom: 20px;
      justify-content: space-between;
      width: 100%;
      height: 42px;
      .tol-item {
        display: flex;
        width: 70%;
        align-items: center;
        justify-content: flex-start;
        .tol-add {
          margin-left: 20px;
        }
        .tol-title {
          margin-right: 6px;
          overflow-wrap: break-word;
          color: rgba(207, 214, 230, 1);
          font-size: 16px;
          font-family: Roboto-Medium;
        }
        .Select-style {
          width: 336px;
          height: 40px;
        }
      }
      .last-page {
        display: flex;
        width: 30%;
        align-items: center;
        justify-content: flex-end;
      }
    }
    .sum-table {
      height: calc(~"100% - 182px");
      padding-top: 4px;
      // 表格
      .sum-table {
        height: 100%;
        .ant-checkbox-inner {
          background-color: transparent;
          border-color: rgba(132, 161, 219, 1);
        }
        //  点击时选框样式
        .ant-checkbox-wrapper-checked {
          .ant-checkbox-checked {
            background: #3384ff;
          }
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
/deep/ .ant-select-selection--single {
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 16px;
}
/deep/ .ant-btn {
  width: 80px;
  height: 40px;
  font-size: 16px;
}

/deep/ .ant-table-thead {
  background: #f0f0f0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #313332;
}

/deep/.ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #313332;
  line-height: 22px;
}

/deep/.ant-switch-checked {
  background: #14cc76;
}

/deep/ .ant-checkbox-wrapper-checked .ant-checkbox-checked {
  background: #14cc76;
}

/deep/ .ant-checkbox-inner {
  border: 1px solid #14cc76;
}

/deep/.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background: #14cc76;
}

/deep/ .ant-checkbox-checked::after {
  border: 1px solid #14cc76;
}

/deep/ .ant-spin-nested-loading {
  height: unset !important;
}

/deep/.ant-modal {
  display: flex;
  justify-content: center;
  width: 1200px !important;
}

/deep/.ant-modal-content {
  width: 1200px !important;
}

/deep/.ant-calendar-picker-input.ant-input {
  height: 40px !important;
}

/deep/.ant-form-item {
  justify-content: flex-end;
}
</style>
